<template>
<div class="page" :style="{ background:colors.indigo }">
  <top-bar fixed />

  <section
      class="location-section pittsburgh-location"
      :style="{ backgroundColor: colors.indigo, paddingTop: '120px' }">

      <vector-canvas
        vector="Schenley"
        class="location-art pittsburgh-location__image"
        :color="colors.indigoDark"
        align-x="mid"
        align-y="max"
        :y-max="1000"
        scale="cover"
        fit-parent
        />

      <!-- v-parallax="0.1" -->
      <date-block
        :month="$t('month-august')" :day="3"
        :city="$t('pittsburgh')" :location="$t('pa-usa')"
        :fg="colors.indigo" :bg="colors.paleYellow"
        class="location-date pittsburgh-location__date"
        />

      <button-block
          class="right-float-button"
          :label="$t('rsvp')"
          :fg="colors.indigoDark"
          :bg="colors.paleYellow"
          v-on:click="openRsvp"
          />
    </section>

    <section>
        <mapbox-block
            :interactive="false"
            :style="{ height:'400px' }"
            :center="[-79.9472808, 40.438439]"
            :zoom="12.5"
            />
        
        <!-- address on paper card + google link -->
        <paper-card
            :style="{ position: 'absolute', right: '20%', bottom: '25%' }"
            >
            <h3>{{ $t('pittsburgh') }}, {{ $t('pa-usa') }}</h3>
            <h3>{{ $t('schenley') }}</h3>
            <button-link 
              :label="$t('map-link')"
              @click="openUrlInTab('https://www.google.com/maps/place/Schenley+Park+Visitors+Center/@40.4383304,-79.9486652,17z/data=!3m1!4b1!4m5!3m4!1s0x8834f18a3d43c849:0x77a937ca776db8a6!8m2!3d40.4383304!4d-79.9464765')"
              :fg="colors.coral"
              />
        </paper-card>
    </section>
</div>
</template>

<script>
// @ is an alias to /src
import DateBlock from '@/components/DateBlock.vue'
import TopBar from '@/components/TopBar.vue'
import VectorCanvas from '@/components/VectorCanvas.vue'
import { colors } from '@/colors.js'
import MapboxBlock from '@/components/MapboxBlock.vue'
import PaperCard from '@/components/PaperCard.vue'
import ButtonBlock from '@/components/ButtonBlock.vue'
import ButtonLink from '@/components/ButtonLink.vue'

export default {
  name: 'pittsburgh',
  components: {
      DateBlock,
      TopBar,
      VectorCanvas,
      MapboxBlock,
      PaperCard,
      ButtonBlock,
      ButtonLink,
  },
  data () {
    return {
      colors
    }
  },
  methods: {
    openUrlInTab (url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
    openRsvp () {
      window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLSfC18iMMvddfDEkVpmzCIZjkjoGXsGLXseAQL9PYKtQe6ur3w/viewform';
    }
  }
}
</script>
